export enum ContentRequestsRouteState {
	SYSTEM_TOOLS = 'system-tools',
	CLIENT_DETAILS = 'client-details',
	CONTENT_REQUESTS = 'content-requests'
}
